// Styles
import "../styles/About.css";
// Third-Party =====> react-bootstrap
import { Col, Container, Row } from "react-bootstrap";
// Third-Paryt
import logo from "../assets/logo.png";
import About1 from "../assets/about1.png";
import About2 from "../assets/about2.png";
import future from "../assets/future.png";
import goals from "../assets/our_goals.png";

const About = () => {
   return (
      <>
         <div className="about" id="about">
            <Container>
               <Row className=" align-items-center justify-content-center">
                  <Col md={6}>
                     <h6 className="greyTitle title">من نحن</h6>
                     <p>
                        شركة "ماتريكس المحدودة المسؤولية" هي إحدى الشركات
                        الرائدة في مجال البرمجيات في سوريا، المتخصصة في تقديم
                        الحلول السحابية والرقمية المتكاملة لتخطيط موارد
                        المؤسسات. تأسست الشركة برقم سجل تجاري 554، وهي تسعى
                        لتحقيق الريادة في مجالها من خلال تقديم تقنيات متطورة
                        وخدمات مبتكرة. يتميز فريقنا بخبرة عميقة وشغف حقيقي
                        بتطوير حلول تقنية تساهم في تحسين أداء المؤسسات وزيادة
                        كفاءتها. من خلال دمج أحدث التقنيات في عملنا، نقدم أدوات
                        فعالة تواكب التحديات التقنية وتدعم نجاح عملائنا.
                     </p>
                     <div className="experience">
                        <span>+10</span>
                        سنين من الخبرة
                     </div>
                  </Col>
                  <Col className="pics" md={6}>
                     <img alt="" src={About2} />
                     <img alt="" src={About1} />

                     <div className="aboutMatrix">
                        <img src={logo} alt="" />
                     </div>
                  </Col>
               </Row>
            </Container>
         </div>
         <div>
            <section className="section">
               <Container>
                  <div className="future">
                     <div className="box">
                        <h2 className="greyTitle title">الرؤية المستقبلية</h2>
                        <p>
                           في نجاحهم.تطمح شركة "ماتريكس" لأن تكون الرائدة في
                           مجال التكنولوجيا الرقمية في سوريا، من خلال تقديم حلول
                           مبتكرة ترتقي بمستوى البرمجيات والتقنيات المستخدمة.
                           نحن نسعى لاستشراف آفاق المستقبل التكنولوجي عبر توظيف
                           أحدث التقنيات مثل الذكاء الاصطناعي وتحليلات البيانات
                           الضخمة. نهدف إلى أن نكون المحور الأساسي في دعم التحول
                           الرقمي للمؤسسات السورية، وبناء شراكات استراتيجية
                           محلية وإقليمية تسهم في تطوير البنية التحتية
                           التكنولوجية وتعزيز النمو الاقتصادي.
                        </p>
                     </div>
                     <div className="future_image">
                        <img src={goals} alt="goals" />
                     </div>
                  </div>
               </Container>
            </section>
            <section className="section">
               <Container>
                  <div className="our-goals">
                     <div className="goals_image">
                        <img src={future} alt="" />
                     </div>
                     <div>
                        <h2 className="greyTitle title">الأهداف</h2>
                        <ul>
                           <li>
                              <h3 className="goal_title">
                                 تطوير حلول متكاملة:{" "}
                              </h3>
                              تقديم منصات برمجية متكاملة تدعم أتمتة العمليات
                              الإدارية والمالية، مما يسهم في تحسين كفاءة
                              المؤسسات وتعزيز قدرتها على التكيف مع التغيرات
                              السوقية.
                           </li>
                           <li>
                              <h3 className="goal_title">
                                 تبني أحدث التقنيات:{" "}
                              </h3>
                              الاستفادة من التقنيات الحديثة مثل الذكاء الاصطناعي
                              وتحليلات البيانات الضخمة لتقديم حلول مبتكرة تتماشى
                              مع أحدث الاتجاهات العالمية في مجال التكنولوجيا.
                           </li>
                           <li>
                              <h3 className="goal_title">
                                 تعزيز التحول الرقمي:{" "}
                              </h3>
                              دعم المؤسسات السورية في تحقيق التحول الرقمي من
                              خلال حلول متطورة تساعدها على تحسين أدائها ورفع
                              مستوى خدماتها.
                           </li>
                           <li>
                              <h3 className="goal_title">
                                 بناء شراكات استراتيجية:{" "}
                              </h3>
                              إقامة علاقات شراكة قوية مع الشركات المحلية
                              والإقليمية لتوسيع نطاق خدماتنا وتقديم حلول تتناسب
                              مع احتياجات السوق المحلي وتساهم في تحقيق التنمية
                              التكنولوجية.
                           </li>
                           <li>
                              <h3 className="goal_title">
                                 الالتزام بالجودة والابتكار:{" "}
                              </h3>
                              تقديم خدمات عالية الجودة تعتمد على أحدث التقنيات
                              وأفضل الممارسات العالمية، مع التركيز على الابتكار
                              المستمر لتلبية تطلعات عملائنا وتحقيق رضاهم الكامل.
                           </li>
                        </ul>
                        <p>
                           من خلال التزامنا بهذه الأهداف، نسعى إلى تعزيز دورنا
                           كمزود رئيسي للحلول التكنولوجية في سوريا ومواكبة
                           التطورات العالمية في مجال البرمجيات.
                        </p>
                     </div>
                  </div>
               </Container>
            </section>
         </div>
      </>
   );
};

export default About;
